import {
  Component,
  effect,
  ElementRef,
  inject,
  input,
  viewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { TooltipModule } from 'primeng/tooltip';
import { CompilingDashboardService } from '../../../../pages/new-compiling-dashboard/compiling-dashboard.service';
import { CompilingSubSectionService } from '../../../../services/compiling/sub-section.service';
import { BaseElementCompilingComponent } from '../../../new-elements/base-element/base-element-compiling.component';

@Component({
  selector: 'lib-compiling-sub-section',
  templateUrl: './sub-section.component.html',
  imports: [
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    TooltipModule,
    BaseElementCompilingComponent,
  ],
  providers: [CompilingSubSectionService],
})
export class CompilingSubSectionComponent {
  protected subSectionService = inject(CompilingSubSectionService);
  private readonly compilingDashboardService = inject(
    CompilingDashboardService,
    {
      optional: true,
    },
  );

  subsection = viewChild<ElementRef<HTMLDivElement>>('ref');

  uniqueId = input.required<string>();

  constructor() {
    effect(() => {
      this.subSectionService.uniqueId = this.uniqueId();
    });

    effect(() => {
      const subsectionToFocus =
        this.compilingDashboardService?.subSectionToFocus();
      if (!subsectionToFocus) return;

      const subsection = this.subsection()?.nativeElement;
      if (!subsection) return;

      if (subsectionToFocus === this.uniqueId()) {
        setTimeout(() => {
          subsection.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
          this.compilingDashboardService?.subSectionToFocus.set(undefined);
        }, 100);
      }
    });
  }
}
